import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'lib-property-recommendation-rating',
  imports: [IonicModule, NgClass],
  templateUrl: './PropertyRecommendationRating.component.html',
  styleUrl: './PropertyRecommendationRating.component.scss',
})
export class PropertyRecommendationRatingComponent implements OnChanges {
  @Input() rating: number = 0;

  public recommendationColorClass = 'RecommendationRating--Medium';

  private setClassColor() {
    let recommendationColorClass = 'RecommendationRating--';

    if (this.rating >= 3) {
      recommendationColorClass += 'High';
    } else if (this.rating === 2) {
      recommendationColorClass += 'Medium';
    } else {
      recommendationColorClass += 'Low';
    }

    this.recommendationColorClass = recommendationColorClass;
  }

  ngOnChanges() {
    this.setClassColor();
  }
}
